export const aciLuggageStorage = {
    iconName: 'luggage-storage',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M13.76 10.453a.07.07 0 00-.069.07v7.397c0 .038.031.07.07.07h5.69c.038 0 .07-.032.07-.07v-7.398a.07.07 0 00-.07-.069h-5.69zm-1.069.07c0-.591.48-1.07 1.07-1.07h5.69c.59 0 1.07.479 1.07 1.07v7.397a1.07 1.07 0 01-1.07 1.07h-5.69a1.07 1.07 0 01-1.07-1.07v-7.398z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M15.75 7.04a.353.353 0 00-.354.353v2.56a.5.5 0 01-1 0v-2.56a1.353 1.353 0 011.354-1.354h1.707a1.353 1.353 0 011.354 1.354v2.56a.5.5 0 01-1 0v-2.56a.354.354 0 00-.354-.354H15.75zM15.326 12.441a.5.5 0 01.5.5v2.988a.5.5 0 01-1 0v-2.988a.5.5 0 01.5-.5zM17.889 12.441a.5.5 0 01.5.5v2.988a.5.5 0 01-1 0v-2.988a.5.5 0 01.5-.5zM14.896 17.988a.5.5 0 01.5.5v.854a.5.5 0 01-1 0v-.854a.5.5 0 01.5-.5zM18.314 17.988a.5.5 0 01.5.5v.854a.5.5 0 01-1 0v-.854a.5.5 0 01.5-.5zM4.48 13.447v4.395c.02.003.043.006.07.006h5.69c.027 0 .05-.003.07-.006v-4.394a.374.374 0 00-.07-.007H4.55a.375.375 0 00-.07.006zm-.6-.822a1.26 1.26 0 01.67-.184h5.69c.237 0 .476.06.67.184.189.119.4.346.4.677v4.685c0 .331-.211.558-.4.678a1.26 1.26 0 01-.67.183H4.55a1.26 1.26 0 01-.67-.183c-.189-.12-.4-.347-.4-.678v-4.685c0-.331.211-.558.4-.677z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M6.541 7.04a.354.354 0 00-.354.353v5.264a.5.5 0 11-1 0V7.393a1.354 1.354 0 011.354-1.354h1.707a1.354 1.354 0 011.354 1.354v5.264a.5.5 0 11-1 0V7.393a.354.354 0 00-.354-.354H6.541zM5.973 14.148a.5.5 0 01.5.5v1.708a.5.5 0 01-1 0v-1.708a.5.5 0 01.5-.5zM8.533 14.148a.5.5 0 01.5.5v1.708a.5.5 0 01-1 0v-1.708a.5.5 0 01.5-.5zM5.688 17.988a.5.5 0 01.5.5v.854a.5.5 0 01-1 0v-.854a.5.5 0 01.5-.5zM9.104 17.988a.5.5 0 01.5.5v.854a.5.5 0 01-1 0v-.854a.5.5 0 01.5-.5zM3.088 4.477a.5.5 0 01.5-.5h16.775a.5.5 0 010 1H3.588a.5.5 0 01-.5-.5zM3.088 21.336a.5.5 0 01.5-.5h16.775a.5.5 0 010 1H3.588a.5.5 0 01-.5-.5z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
